export const apiRoutes = {
  GET_ALL_BLOG: "/api/blog/get-all-blog",
  GET_SPECIFIC_BLOG: "/api/blog/get-specific-blog",
  GET_ALL_FAQ: "/api/faq/get-all-faqs",
  GET_SPECIFIC_FAQ: "/api/faq/get-specific-faq",
};
